import React from "react";
import { Zap, DollarSign, Users, BarChart3, Headphones } from "lucide-react";

const features = [
  { icon: Zap, title: "Fast Results" },
  { icon: DollarSign, title: "Affordable Pricing" },
  { icon: Users, title: "Expert Team" },
  { icon: BarChart3, title: "Guaranteed Results" },
  { icon: Headphones, title: "24/7 Support" }
];

function WhyChooseUs() {
  return (
    <section className="relative py-16 px-6 bg-white dark:bg-[#050505] overflow-hidden">

      {/* BACKGROUND GLOW */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID */}
      <div className="absolute inset-0 opacity-60 bg-[linear-gradient(to_right,rgba(0,0,0,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,0,0,0.06)_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,rgba(255,255,255,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.06)_1px,transparent_1px)] bg-[size:60px_60px]" />

      {/* CONTENT */}
      <div className="relative z-10 max-w-7xl mx-auto">

  <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
                Why Choose Us for {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
           Digital Marketing
            </span>
          </h2>
   <p className="myparagraph text-gray-500">
 We focus on results, performance, and long-term growth.</p>
      </div>
     

        {/* GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">

          {features.map((item, i) => (
            <div
              key={i}
              className="group p-6 rounded-2xl border border-gray-100 dark:border-gray-800 bg-white/70 dark:bg-[#111]/70 backdrop-blur-md hover:shadow-xl transition-all duration-300 text-center"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-orange-50 dark:bg-orange-900/20 mb-4 group-hover:scale-110 transition">
                <item.icon className="w-6 h-6 text-primary" />
              </div>

              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                {item.title}
              </h3>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;